const SvgNoContent = () => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width={90} height={90} strokeWidth={0.5}>
      <path
        clipRule="evenodd"
        d="M20 20.6667C20 21.403 19.449 22 18.7692 22H5.23077C4.55103 22 4 21.403 4 20.6667V3.33333C4 2.59695 4.55103 2 5.23077 2H13.952C14.2782 2.00008 14.591 2.14043 14.8217 2.39022L19.6398 7.60978C19.8704 7.85973 19.9999 8.19862 20 8.552V20.6667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M20 8.66667H15.077C14.3972 8.66667 13.8462 8.06971 13.8462 7.33333V2"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M7.24101 11.6391C7.60164 12.1522 8.17066 12.4425 8.76552 12.4168C9.70008 12.4168 10.4582 11.8008 10.4582 11.0417C10.4582 10.2826 9.70255 9.6675 8.7688 9.6675C7.83506 9.6675 7.0769 9.0515 7.0769 8.2915C7.0769 7.5315 7.83506 6.91639 8.7688 6.91639C9.36375 6.89027 9.93295 7.18066 10.2933 7.69417"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path d="M8.76868 12.417V13.3334" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M8.76868 6V6.91644" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M12 14.6667H16.9231" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M7.69226 18.6667H16.923" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  )
}

export default SvgNoContent
